export default __webpack_public_path__ + "static/media/CourtSelection3PT.9090972c.png";